import * as React from "react"
import { List } from "immutable"
import { QuickLinks, QuickLink } from "./quick_links";
import { pushBuildingBlockAction } from "./datalayer";

export type SubMenuProps = {
  readonly kind: "submenu"
  title: string
  text: string
  links: List<QuickLink>
}

export class SubMenuBlock extends React.Component<SubMenuProps, {}> {

  componentDidMount() {
    this.scrollToGroupByCurrentHash()
    window.addEventListener("hashchange", () => this.scrollToGroupByCurrentHash())
  }

  scrollToGroupByCurrentHash() {
    this.scrollToGroup(window.location.hash.substring(1))
  }

  scrollToGroup(slug: string) {
    const element = document.querySelector(`[data-anchor="${slug}"]`)
    if (!element) return
    element.scrollIntoView({ behavior: "smooth" })
  }

  render() {
    const { title, text, links } = this.props

    return (
      <section className="block block--knowledge-bank">
        {(title) &&
          <header className="block__header">
            {title && <h2 className="block__title title--l">{title}</h2>}
          </header>
        }

        <QuickLinks
          title={text}
          links={links}
          slider={true}
          handleScroll={(slug: string) => this.scrollToGroup(slug)}
          pushAnalyticsEvent={(action: string) => pushBuildingBlockAction(action)}
        />
      </section>
    )
  }
}
